<template>
    <svg viewBox="0 0 765 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMaxYMax meet">
        <g fill="none" fill-rule="evenodd">
            <path d="M16 .8C9.43958638.5.5 8.43958638.9 16c0 20.5604136 16.93958638 15.5 105.5 15.5h633c8.560414 0 15.5-6.9395864 15.5-15.5 0-8.56041362-6.939586-15.5-15.5-15.5H16z" stroke="#A2B0D5"/>
            <path d="M17 1h550c8.284271 0 15 6.71572875 15 15 0 8.2842712-6.715729 15-15 15H17C8.71572875 31 2 24.2842712 2 16 2 7.71572875 8.71572875 1 17 1z" fill="#5478A6" fill-rule="nonzero"/>
            <text font-family="OpenSans, Open Sans" font-size="15" fill="#FFF" dominant-baseline="central">
            <tspan x="50.4160156" y="16">{{ stageHeaders.personalInfo }}</tspan>
            </text>
            <text font-family="OpenSans, Open Sans" font-size="15" fill="#FFF" dominant-baseline="central">
            <tspan x="250" y="16">{{ stageHeaders.subscription }}</tspan>
            </text>
            <text font-family="OpenSans-Semibold, Open Sans" font-size="15" fill="#FFF" dominant-baseline="central">
            <tspan x="447.953125" y="16">{{ stageHeaders.payment }}</tspan>
            </text>
            <text font-family="OpenSans, Open Sans" font-size="15" fill="#fff" font-weight="500" dominant-baseline="central">
                <tspan x="610" y="16">{{ stageHeaders.confirmation }}</tspan>
            </text>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['stageHeaders']
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/SVG/step6.vue